// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__seriP","approved":"Status_approved__sLo1z","rejected":"Status_rejected__3nkuz","expired":"Status_expired__SDz-I","label":"Status_label__1E5yp"};